import { action, observable, ObservableMap } from 'mobx'
import { stores } from '@stores'
import { computedFn } from 'mobx-utils'
import { ProductPresentationService } from '@modules/showroom/productCollection/service/ProductPresentation'

export class ProductPricesStore {
  @observable prices = new ObservableMap()
  private apiService = new ProductPresentationService()
  @observable isPriceLoading = new ObservableMap()
  @observable bsgStatus = ''

  @action fetchPriceData = (clientId, bsgId) => {
    if (!bsgId || !clientId) return
    if (!this.prices.has(clientId + bsgId) && this.isPriceLoading) {
      this.isPriceLoading.set(clientId + bsgId, true)
      this.apiService
        .getProductPrices(bsgId, clientId)
        .then(response => {
          this.prices.set(clientId + bsgId, response)
          this.isPriceLoading.set(clientId + bsgId, false)
          this.bsgStatus = response?.buyingSessionGroup?.status
        })
        .catch(error => {
          this.prices.set(clientId + bsgId, null)
          this.isPriceLoading.set(clientId + bsgId, false)
        })
    }
  }

  /**
   * Function which will return the prices of products .
   */
  getPriceForProduct = computedFn(productId => {
    const {
      nav: {
        queryParams: { clientId, buyingSessionGroupId }
      }
    } = stores

    const price = this.prices.get(clientId + buyingSessionGroupId)
    return {
      rtlCurrency: price?.prices?.[productId]?.retailProductCurrency ?? '',
      whlCurrency: price?.prices?.[productId]?.wholesaleProductCurrency ?? '',
      retailProductPrice: price?.prices?.[productId]?.retailProductPrice,
      wholesaleProductPrice: price?.prices?.[productId]?.wholesaleProductPrice,
      kpiCurrency: price?.kpiCurrency
    }
  })

  getPriceLoading = computedFn((clientId, buyingSessionGroupId) => {
    const isPriceLoading = this.isPriceLoading.get(clientId + buyingSessionGroupId)
    return isPriceLoading
  })

  getWhlCurrency = computedFn(
    (clientId, buyingSessionGroupId) =>
      this.prices.get(clientId + buyingSessionGroupId)?.whlCurrency
  )
}

export const productPriceStore = new ProductPricesStore()
